// Generated by scripts/write-release.mjs — do not edit.
export const APP_RELEASE = 'cb9e0aadcb0edce1f237ae76f48cc4672f64c7b3';
